import { Facebook, Twitter, Instagram} from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-info">
          <img src="/images/logo/logo.png" alt="Pompano Garment Manufacturing" className="footer-logo" />
          <p>Area 18B | After Super Kids School<br />Lilongwe</p>
          <p>+265 884 996 996</p>
          <p>orders@pompanomw.com</p>
        </div>
        <div className="footer-hours">
          <h4>Business Hours</h4>
          <p>Mon–Fri: 9:00–18:00</p>
          <p>Mon–Sat: 7:00–20:00</p>
          <p>Sun: 8:00–17:00</p>
        </div>
        <div className="footer-social">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><Facebook /></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><Twitter /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><Instagram /></a>
            <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.59 6.69C18.95 6.69 18.38 6.45 17.97 6.05C17.56 5.65 17.32 5.08 17.32 4.44V4H14.86V16.16C14.86 17.3 14.31 18.33 13.44 19.01C12.94 19.4 12.33 19.66 11.67 19.75C11.01 19.84 10.34 19.75 9.73 19.5C9.12 19.25 8.6 18.85 8.22 18.33C7.84 17.81 7.63 17.21 7.63 16.6C7.63 15.99 7.84 15.39 8.22 14.87C8.6 14.35 9.12 13.95 9.73 13.7C10.34 13.45 11.01 13.36 11.67 13.45V10.96C10.86 10.87 10.05 10.96 9.3 11.23C8.55 11.5 7.87 11.94 7.31 12.52C6.75 13.1 6.33 13.8 6.09 14.57C5.85 15.34 5.8 16.15 5.95 16.94C6.1 17.73 6.44 18.47 6.94 19.09C7.44 19.71 8.09 20.2 8.83 20.51C9.57 20.82 10.38 20.95 11.18 20.88C11.98 20.81 12.75 20.55 13.44 20.13C14.13 19.71 14.72 19.13 15.17 18.45C15.62 17.77 15.91 17 16.02 16.2V10.38C17.08 11.1 18.31 11.52 19.59 11.52V9.04C18.73 9.04 17.93 8.73 17.32 8.18V6.69H19.59Z" fill="currentColor"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Pompano Garment Manufacturing. All rights reserved. Developed by <a href="https://imperialsystemsmw.com/" target="_blank" rel="noopener noreferrer">Imperial Systems</a> in collaboration with <a href="https://www.beleae.com/" target="_blank" rel="noopener noreferrer">Belea</a></p>
      </div>
    </footer>
  );
};

export default Footer;
